var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showErrorAlert, loaderHandler } from './helpers';
const handleClearAccessibleDocsTable = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const formData = new FormData();
        formData.append('action', 'accessible_docs_clear_table');
        formData.append('nonce', accessible_docs_object.nonce);
        const response = yield fetch(accessible_docs_object.ajax_url, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            showErrorAlert(`Request failed with status: ${response.status}`);
            throw new Error(`Request failed with status: ${response.status}`);
        }
        const result = yield response.json();
        return result.data;
    }
    catch (error) {
        showErrorAlert(error);
        throw new Error(`Error: ${error}`);
    }
});
const initClearDocumentsTable = () => {
    const clearButton = document.querySelector('.js-clear-table-button');
    if (clearButton) {
        clearButton.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
            if (window.confirm(clearButton.dataset.text)) {
                loaderHandler('add');
                const request = yield handleClearAccessibleDocsTable();
                if (request.status === 'success') {
                    window.location.href = `${window.location.origin}${window.location.pathname}?page=accessible-docs-admin-documents-list`;
                }
                else {
                    loaderHandler('remove');
                    alert(request.error);
                }
            }
        }));
    }
};
export default initClearDocumentsTable;
